import { useCallback } from 'react';

import { SecondaryPageLayoutLoading } from '@/_containers/layout/secondary-page-layout';
import DomainsLoading from '@/_pages/settings/registrars/domains/loading';
import { subNav } from '@/_pages/settings/registrars/model';
import ProfileLoading from '@/_pages/settings/registrars/profile/loading';
import { useCurrentLocation } from '@/_shared';

export function TemplateLoading() {
  const { matched } = useCurrentLocation();
  const { tabKey } = matched?.staticData ?? {};

  const render = useCallback(() => {
    switch (tabKey) {
      case 'settings/registrar/domains':
        return <DomainsLoading />;
      case 'settings/registrar/profile':
      default:
        return <ProfileLoading />;
    }
  }, [tabKey]);

  return <SecondaryPageLayoutLoading subNavLinks={subNav}>{render()}</SecondaryPageLayoutLoading>;
}
